import { useQuery } from '@tanstack/react-query';
import { useApi } from 'common/hooks/api';

export const useRenderDataItinerary = id => {
  const Api = useApi();
  return useQuery({
    queryKey: ['renderDataItinerary', id],
    queryFn: async () => {
      const response = await Api.get(`/api/PresentationEdits/renderDataItinerary?itineraryId=${id}&includeAllImages=1`);
      return response.data;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: (_failureCount, error) => {
      if (error?.response?.status === 404) return false;
      return true;
    },
  });
};

export const useRenderDataSavedItinerary = (id, { agencyId, agentId } = {}) => {
  const Api = useApi();
  return useQuery({
    queryKey: ['renderDataSavedItinerary', id],
    queryFn: async () => {
      const params = new URLSearchParams({ savedItineraryId: id });
      if (agencyId) params.append('agencyId', agencyId);
      if (agentId) params.append('agentId', agentId);
      const response = await Api.get(`/api/PresentationEdits/renderDataSavedItinerary?${params}`);
      return response.data;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: (_failureCount, error) => {
      if (error?.response?.status === 404) return false;
      return true;
    },
  });
};
